import { Button, Grid, Stack, CircularProgress } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { MenuInfoContext } from '../../home/MenuInfoContext';
import { RestauInfoContext } from '../../home/RestauInfoContext';
import ExcelHandling from '../ExcelHandling/ExcelHandling';
import SelectFoodTemplate from '../SelectFoodTemplate';
import SwitchWithLabel from '../../components/common/SwitchWithLabel';

export default function MenuSettings() {
    const [template, setTemplate] = React.useState('');
    const [showPPP, setShowPPP] = React.useState(true);
    const menuHook = useContext(MenuInfoContext);
    const { restauHook } = useContext(RestauInfoContext);
    const [updatingShowPPP, setUpdatingShowPPP] = React.useState(false);

    function templateOnChange(e, menuHook) {
        let val = menuHook.value;
        val.menu.template = e.target.value;
        menuHook.setValue(val);
        setTemplate(val.menu.template);
    }

    // function showPPPOnChange(checked) {
    //     let val = menuHook.value;
    //     val.menu.showPPP = checked;
    //     menuHook.setValue(val);
    //     setShowPPP(val.menu.showPPP);
    // }

    async function updateTemplate() {
        let updates = {};
        const database = window.customerApp.database();

        updates['menus/' + restauHook.restauId + '/template'] = template;
        console.log(updates);
        await database
            .ref()
            .update(updates)
            .then(function () {})
            .catch(function (error) {
                alert('Error while saving please try again');
                //Need to pop error someways
                console.log(error);

                return;
            });
    }

    async function updateShowPPP() {
        let updates = {};
        const database = window.customerApp.database();

        setUpdatingShowPPP(true);
        updates['menus/' + restauHook.restauId + '/showPPP'] = showPPP;
        console.log(updates);
        await database
            .ref()
            .update(updates)
            .then(function () {
                //update the menuHook
                let val = menuHook.value;
                val.menu.showPPP = showPPP;
                menuHook.setValue(val);
                setUpdatingShowPPP(false);
            })
            .catch(function (error) {
                alert('Error while saving please try again');
                //Need to pop error someways
                console.log(error);
                setUpdatingShowPPP(false);
                return;
            });
    }

    useEffect(() => {
        //console.log(restauHook);
        setTemplate(menuHook.value?.template);
        setShowPPP(menuHook.value?.showPPP);
    }, []);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Stack spacing={2} direction="row">
                    <SelectFoodTemplate
                        template={template}
                        onTemplateChange={(e) => {
                            templateOnChange(e, menuHook);
                        }}
                    />

                    <Button
                        onClick={updateTemplate}
                        size="small"
                        color="primary"
                        variant="contained"
                        style={{ maxHeight: '50px' }}
                    >
                        {'Update Template'}
                    </Button>
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <Stack spacing={2} direction="row">
                    <SwitchWithLabel
                        xs={6}
                        id="switchForppp"
                        size="medium"
                        name="switch-for-price-per-person"
                        label="Show Price per Person in Food Dialog"
                        checked={showPPP}
                        onChangeHandler={(checked) => setShowPPP(checked)}
                    />

                    <Button
                        onClick={updateShowPPP}
                        disabled={updatingShowPPP}
                        size="small"
                        color="primary"
                        variant="contained"
                        style={{ maxHeight: '50px' }}
                    >
                        {'Update'}
                        {updatingShowPPP && (
                            <CircularProgress
                                size={22}
                                style={{ color: 'black' }}
                            />
                        )}
                    </Button>
                </Stack>
            </Grid>
            <Grid item>
                <ExcelHandling
                    restauId={restauHook.restauId}
                    refreshMenu={menuHook.refreshData}
                />
            </Grid>
        </Grid>
    );
}
